<template>
    <div class="f-form-item">
        <span class="f-form-label">
            <span v-if="formConfig.validations && formConfig.validations.required"
                class="f-form-label-required">*</span>
            <span>{{formConfig.label}}</span>
            <span v-if="formConfig.encryptType"
                class="fa fa-lock"
                :tip="secretTip">
            </span>
        </span>

        <div v-if="formConfig.type==='buttonbox'" class="f-form-buttonbox">
            <span v-for="item in formConfig.options"
                :key="item.label"
                :class="{'f-form-buttonbox-item': true, 'f-form-buttonbox-item-active': formConfig.defaultValue === item.value}"
                @click="chooseOne(item.value)">
                {{item.label}}
            </span>
        </div>

        <div v-if="formConfig.type==='input'" class="f-form-input">
            <input class="f-form-input-text"
                type="text"
                v-model="formConfig.defaultValue" 
                @input="countContent"
                @blur="blurChange"
                @focus="focusChange"
                name="input"
                :maxlength="inputMaxLen"
                :placeholder="formConfig.placeholder"
                autocomplete="off"
                v-validate="{'required': formConfig.validations.required > 0,
                    'max': validateMaxLen}"
                v-validate.disable="!formConfig.validations">
            <div class="f-form-input-cont">
                <span>{{count}}</span>
                <span>/{{formConfig.validations.maxLength}}</span>
            </div>
            <div class="f-form-errors-input" style="color:#4e6ef2" v-if="formConfig.guide && formConfig.guide.length > 0" @click="showMethod(formConfig.label, formConfig.guide)">
                获取{{formConfig.label}}方式
            </div>
            <div v-if="errors.has('input')" class="f-form-errors-input">
                {{errors.first('input')}}
            </div>
            <!-- 发帖sug -->
            <div class="f-form-input-sug"
                v-if="titleSugList.length
                    && titleIsFocus && formConfig.isTitle
                    && formConfig.defaultValue.length > 1">
                <div class="f-form-input-sug-title">
                    <span>相关链接</span>
                    <!-- <span>没有找到相关内容</span> -->
                </div>
                <div class="f-form-input-sug-result">
                    <div class="f-form-input-sug-item"
                    v-for="item in titleSugList"
                    :key="item.id"
                    @mousedown="mouseDown">
                        <div v-if="item.from === 'devforum'">
                            <span class="f-form-input-sug-item-type">【社区】</span>
                            <a class="f-form-input-sug-item-title" @click="navigatToTopic(item)">
                                {{ item.title }}
                            </a>
                            <span class="f-form-input-sug-item-replay">{{item.replyCount}}条回答</span>
                            <span class="f-form-input-sug-item-tag">[{{item.boardName}}]</span>
                        </div>
                        <div v-else>
                            <span class="f-form-input-sug-item-type">【文档】</span>
                            <a class="f-form-input-sug-item-title" @click="navigateToSmart(item)">
                                {{item.title}}
                            </a>
                            <span class="f-form-input-sug-item-tag">[{{item.boardName}}]</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="formConfig.type==='radio'" class="f-form-radio">
            <veui-radio-group
                v-model="formConfig.defaultValue"
                :items="formConfig.options"
            />
            <div v-if="formConfig.label==='使用场景'" class="f-form-additional-radio">
                场景描述详见<a target="_blank" class="f-form-additional-a" href="https://smartprogram.baidu.com/docs/develop/function/webintroduction/">文档</a>
            </div>
        </div>

        <div v-if="formConfig.type==='checkbox'" class="f-form-checkbox">
            <label v-for="item in formConfig.options"
                :key="item.value"
                class="f-form-checkbox-item">
                <input type="checkbox"
                    name="checkbox"
                    class="f-form-checkbox-item-icon"
                    style="margin-top:12px"
                    v-validate="{'required': formConfig.validations.required}"
                    v-validate.disable="!formConfig.validations"
                    v-model="formConfig.defaultValue"
                    :value="item.value"><span style="height:30px;line-height:30px;margin-top:10px">{{item.label}}</span>
            </label>
            <span v-if="errors.has('checkbox')" class="f-form-errors-checkbox">{{errors.first('checkbox')}}</span>
        </div>

        <div v-if="formConfig.type==='datetime'" class="f-form-date">
            <el-date-picker
                v-model="defaultTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :editable="canEditTime"
                @change="setSelectedTime">
            </el-date-picker>
        </div>

        <div v-if="formConfig.type==='radioInput'" class="f-form-radio">
            <veui-radio-group class="f-form-radio-radio"
                v-model="radioValue"
                @change="changeDefaultValue"
                :items="formConfig.options"
            />
            <input v-if="radioValue === 'INPUT'"
                class="f-form-radio-input"
                maxlength="6"
                v-model="formConfig.defaultValue"
                placeholder="不超过六个字">
        </div>

        <div v-if="formConfig.type==='textarea'" class="f-form-input f-form-textarea">
            <textarea class="f-form-textarea-text"
                name="textarea"
                autocomplete="off"
                v-model="formConfig.defaultValue"
                :placeholder="formConfig.placeholder"
                :maxlength="formConfig.validations.maxLength"
                v-validate="{'required': formConfig.validations.required > 0,
                    'max': formConfig.validations.maxLength}"
                v-validate.disable="!formConfig.validations">
            </textarea>
            <div class="f-form-textarea-cont">
                <span>{{count}}</span>
                <span>/{{formConfig.validations.maxLength}}</span>
            </div>
            <div v-if="errors.has('textarea')" class="f-form-errors-textarea">
                {{errors.first('textarea')}}
            </div>
        </div>
        <div v-if="methodModal" class='modal'>
            <div class="modal-div">
                <div class="modal-title"> {{title}}
                    <span class="f-form-input-close" style="z-index:11" @click="cancelHandler()"></span>
                </div>
                <div  class="modal-img">
                    <img :src="method_img_url" style="width:720px;height:366px;">
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/edit-topic/render-component.less';
</style>

<script>
import {RadioGroup} from 'veui';
import {debounce} from '@/utils/debounceThrottle';
import {mapState} from 'vuex';

const padZeros = num =>
    (num + '').padStart(2, '0');

const formatDateTime = date =>
    date.getFullYear()
        + '-'
        + padZeros(date.getMonth() + 1)
        + '-'
        + padZeros(date.getDate())
        + ' '
        + padZeros(date.getHours())
        + ':'
        + padZeros(date.getMinutes())
        + ':'
        + padZeros(date.getSeconds());

export default {
    props: {
        formName: String,
        formConfig: Object,
        editorPlaceHolder: {
            'type': Object,
            'default': () => {
                return {};
            }
        }
    },
    components: {
        'veui-radio-group': RadioGroup
    },
    watch: {
        'formConfig.defaultValue'() {
            // title输入时，获取sug
            if (this.formConfig.isTitle) {
                // 内容为空时
                debounce(() => {
                    if (this.formConfig.defaultValue.length <= 1) {
                        this.titleSugList = [];
                        return;
                    }
                    this.$store.dispatch('getTitleSug', this.formConfig.defaultValue);
                }, 300)();
            }
        }
    },
    computed: {
        ...mapState({
            secretTip: state => state.editTopic.secretTip
        }),
        inputMaxLen: {
            get() {
                return this.formConfig.validations.maxLength;
            }
        },
        validateMaxLen: {
            get() {
                if (this.formConfig.label === '帖子标题') {
                    return Math.max(
                        this.$store.state.editTopic.issueTitleLen,
                        this.$store.state.editTopic.notIssueTitleLen
                    );
                }
                return this.formConfig.validations.maxLength;
            }
        },
        count: {
            get() {
                return this.formConfig.defaultValue.length;
            },
            set(newVal) {
                return newVal;
            }
        },
        radioValue: {
            get() {
                for (let opt of this.formConfig.options) {
                    if (opt.value === this.formConfig.defaultValue) {
                        return this.formConfig.defaultValue;
                    }
                }
                return 'INPUT';
            },
            set(newVal) {
                return newVal;
            }
        },
        titleSugList: {
            get() {
                return this.$store.state.editTopic.titleSugList;
            },
            set(newVal) {
                this.$store.state.editTopic.titleSugList = newVal;
            }
        }
    },
    data() {
        return {
            defaultTime: this.formConfig.defaultValue ? this.formConfig.defaultValue : formatDateTime(new Date()),
            canEditTime: false,
            titleIsFocus: false,
            origin: window.location.origin,
            methodModal: false,
            title: '',
            method_img_url: '',
        };
    },
    mounted() {
        if (this.formName) {
            this.$store.commit('addComponent', this.formName);
        }

        if (this.formConfig.type === 'datetime') {
            this.setSelectedTime();
        }
    },
    updated() {
        if (Object.keys(this.editorPlaceHolder).length) {
            let placeholder = this.editorPlaceHolder[this.formConfig.defaultValue];
            this.$emit('changeEditPlaceholder', placeholder);
        }
    },
    beforeDestroy() {
        this.$store.commit('removeComponent', this.formName);
    },
    methods: {
        countContent() {
            this.count = this.formConfig.defaultValue.length;
        },
        focusChange() {
            this.titleIsFocus = true;
        },
        blurChange() {
            this.titleIsFocus = false;
        },
        chooseOne(id) {
            this.formConfig.defaultValue = id;
        },
        changeDefaultValue(value) {
            if (value === 'INPUT') {
                this.formConfig.defaultValue = '';
            }
            else {
                this.formConfig.defaultValue = value;
            }
        },
        setSelectedTime() {
            this.formConfig.defaultValue = this.defaultTime;
        },
        navigatToTopic(item) {
            if (item.type === 3) {
                _hmt.push(['_trackEvent', '发帖sug', '社区', `https://smartprogram.baidu.com/forum/issue/show/${item.issueId}`]);
                window.open(`/forum/issue/show/${item.issueId}`);
            }
            else {
                _hmt.push(['_trackEvent', '发帖sug', '社区', `https://smartprogram.baidu.com/forum/topic/show/${item.id}`]);
                window.open(`/forum/topic/show/${item.id}`);
            }
        },
        mouseDown(e) {
            let event = e || window.event;
            event.preventDefault();
        },
        // sug文档内容打点上报至百度统计
        navigateToSmart(item) {
            _hmt.push(['_trackEvent', '发帖sug', '文档', `${this.origin}${item.path}`]);
            window.open(`${this.origin}${item.path}`);
        },
        showMethod(title, guide) {
            this.title = '获取' + title + '方式';
            this.method_img_url = guide;
            this.methodModal = true;
        },
        cancelHandler() {
            this.methodModal = false;
        }
        
    }
};
</script>